module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/conscientiousness/c26ad740711c77089f7106d2ea67026a.png";